import React, {Component} from 'react';
import moment from 'moment';
import {
  switchYear,
  switchMonth,
  fetchSelectedUserInfo
} from 'actions/UserActions';
import { Button } from 'react-bootstrap';
import HolidayModal from './HolidayModal'

const YearSelector = ({year, dispatch, loadingUserData}) => {
  let start = parseInt(moment().format("YYYY"), 10) - 10;

  return (
    <select
      className="form-control year"
      value={year}
      disabled={loadingUserData}
      onChange={(e) => {
        dispatch(switchYear(e.target.value));
        dispatch(fetchSelectedUserInfo());
      }}
    >
      {[...Array(20).keys()].map((offset)=> (
        <option key={start + offset} value={start + offset}>
          {start + offset}
        </option>
      ))}
    </select>
  )
}

const MonthSelector = ({month, dispatch, loadingUserData}) => {
  let start = moment("20171231", "YYYYMMDD");

  return (
    <select
      className="form-control month"
      value={month}
      disabled={loadingUserData}
      onChange={(e) => {
        dispatch(switchMonth(e.target.value));
        dispatch(fetchSelectedUserInfo());
      }}
    >
      {[...Array(12).keys()].map(()=> {
          let month = start.add(1, 'month').format('MM');

          return (
          <option key={month} value={month}>
            {month}
          </option>
        )}
      )}
    </select>
  )
}

class MonthSelectorl extends Component {
  state = {
    setHoliday: false
  }

  activeHolidayModal = () => {
    this.setState({
      setHoliday: true
    })
  }

  dismissHolidayModal = () => {
    this.setState({
      setHoliday: false
    })
  }

  render() {
    let {year, month, dispatch, loadingUserData} = this.props;
    let { setHoliday } = this.state;
    return (
      <div className="panel-heading">
        <div className="ws-month-panel">
          <Button className="btn btn-primary" onClick={this.activeHolidayModal}>
            設定本月假期
          </Button>
          { setHoliday 
              && <HolidayModal
                    dismiss={this.dismissHolidayModal}
                    dispatch={dispatch}
                    loadingUserData={loadingUserData} 
                  />}
          <form className="form-inline month-selector">
            <YearSelector year={year} dispatch={dispatch} loadingUserData={loadingUserData}/>
            {" "}
            <MonthSelector month={month} dispatch={dispatch} loadingUserData={loadingUserData}/>
          </form>
        </div>
      </div>
    )
  }
}

export default MonthSelectorl;



// WEBPACK FOOTER //
// ./src/components/Worker/MonthSelector.js